app.component('packageCreate', {
    bindings: {
        show: '=',
        packages: '<',
        isZipLinkImport: '<',
        zipLinkUrl: '=',
        isValidZipUrl: '='
    },
    templateUrl: './App/Packages/PackageCreate.html',
    controller: ['$scope', 'sessions', 'growl', '$location', 'packageService',
        function ($scope, sessions, growl, $location, packageService) {
            var that = this;

            that.init = function () {
                that.session = sessions.getCurrent();
                that.mode = 'agent-search';
                that.confirmCreateIsOpen = false;
                that.confirmCreateMessage = false;
                that.confirmCreateIsProcessing = false;
                that.isCreatingPackage = false;
                that.importExistingPhotos = false;
                that.showAddressOnlyOption = false;
                that.isValidating = false;
                that.dropboxAutoPublish = false;
                that.uploadAttestation = false;
                that.confirmAttestation = false;

                if (that.session.isAgent === true) {
                    that.selectAgent({ MemberMlsId: that.session.username });
                }
            };

            that.back = function () {
                if(that.mode == 'confirm') {
                    that.mode = 'listing-search';
                } else if (that.mode == 'listing-search' && !that.session.isAgent) {
                    that.mode = 'agent-search';
                }  else { //that.mode == 'agent-search'
                        that.show = false;
                }
            }

            that.selectAgent = function (agent) {
                that.selectedAgent = agent;
                that.mode = 'listing-search';
            }

            that.searchFinished = function () {
                that.showAddressOnlyOption = true;
            }

            that.createPackage = function () {
                that.isCreatingPackage = true;

                packageService.createPackage({
                    listingId: that.selectedListing?.ListingId,
                    memberMlsId: that.selectedAgent?.MemberMlsId,
                    address: that.listingAddress,
                    //importExistingPhotos: that.importExistingPhotos,
                    onSuccess: pkg => {
                        if (that.importExistingPhotos) {
                            if (!pkg.isNew) {
                                growl.success('Package already exists. Photos not imported', { ttl: 10000 });
                                that.handleDropboxUrl(pkg.MediaPackageId);
                            } else {
                                packageService.importMlsPhotos({
                                    package: pkg,
                                    onSuccess: importPkg => {
                                        growl.success(`Package created, ${importPkg.Photos.length} MLS photos imported`, { ttl: 10000 });
                                        that.handleDropboxUrl(importPkg.MediaPackageId);
                                    }
                                });
                            }
                        } else {
                            that.handleDropboxUrl(pkg.MediaPackageId);
                            growl.success(pkg.isNew ? 'Package created' : 'Package already exists');
                        }
                        that.confirmAttestation = false;
                    },
                    onError: _ => {
                        that.createFinished();
                    }
                });
            }

            //that.checkValidZipLink = function (e) {
            //    that.isValidating = true;
            //    try {
            //        const downloadUrl = new URL(that.zipLinkUrl);
            //        if (downloadUrl.hostname.includes('dropbox.com'))
            //            downloadUrl.searchParams.set('dl', '1');

            //        console.log('checkValidZipLink', downloadUrl);
            //        fetch(downloadUrl.href, { method: 'HEAD' })
            //            .then(r => {
            //                const contentType = r.headers.get('Content-Type');
            //                that.isValidZipUrl = contentType == 'application/zip';
            //                that.isValidating = false;
            //            });
            //    } catch (e) {
            //        that.isValidZipUrl = false;
            //        that.isValidating = false;
            //    }
            //}
            that.handleValidZipUrl = function () {
                that.isValidating = true;
                packageService.isValidZipUrl(that.zipLinkUrl)
                    .then(r => {
                        that.isValidZipUrl = r.isValid;
                        that.isValidating = false;
                    });
            };

            that.zipUrlHasValue = function () {
                return that.zipLinkUrl !== undefined && that.zipLinkUrl !== null && that.zipLinkUrl !== '';
            }

            that.handleCreateFromZipUrl = function () {
                if (that.isValidZipUrl)
                    that.showCreatePackage = true;
            };

            that.handleDropboxUrl = function(packageId) {
                if (that.zipLinkUrl !== null) {
                    var uploadRequest = {
                        PackageId: packageId,
                        DropboxUrl: that.zipLinkUrl,
                        AutoPublish: that.dropboxAutoPublish
                    };

                    packageService.uploadDropboxUrl(uploadRequest,
                        success => {        
                            if (that.dropboxAutoPublish) {
                                growl.success('Photo import & publish scheduled', { ttl: 5000 });
                                that.dropboxAutoPublish = false;
                                that.isCreatingPackage = false;
                                that.confirmCreateIsOpen = false;
                                that.confirmCreateIsProcessing = false;
                                that.zipLinkUrl = null;
                                $scope.$emit('packageUpdated');
                                that.show = false;
                            } else {
                                growl.success('Importing photos', { ttl: 5000 });
                                that.createFinished(packageId);
                            }
                        },
                        error => {
                            growl.error('An error occurred while processing the import link', { ttl: 5000 });
                            that.createFinished(packageId);
                        });
                }
                else {
                    that.createFinished(packageId);
                }
            }

            that.createFinished = function (navigateToPackageId) {
                that.isCreatingPackage = false;
                that.confirmCreateIsOpen = false;
                that.confirmCreateIsProcessing = false;
                that.zipLinkUrl = null;
                if (that.selectedListing)
                    that.selectedListing.isProcessing = false;

                if (navigateToPackageId) {
                    $scope.$emit('packageUpdated');
                    that.viewPackage(navigateToPackageId);
                }
            };

            that.viewPackage = function (packageId) {
                $location.url(`/packages/${packageId}`);
            }

            that.confirmCreatePackage = function (listing) {
                that.selectedListing = listing;
                that.mode = 'confirm';
            }

            that.onPackageCreateSuccess = function (response) {
                var package = response.data;
                that.session = sessions.updatePackage(package);
                that.isCreatingPackage = false;
                $location.url(`/packages/${package.MediaPackageId}`);
            }

            that.init();
        }]
});